import { useEffect, useRef } from 'react';

export function useBeforePageUnload(shoulUnload: () => Promise<boolean>) {
  const popStateCb = useRef<() => void>();

  useEffect(() => {
    popStateCb.current = () => {
      shoulUnload().then((isConfirmed) => {
        if (isConfirmed) {
          window.removeEventListener('popstate', popStateCb.current);
          history.back();
        } else {
          setTimeout(() => {
            history.pushState({ needConfirm: true }, null);
          });
        }
      });
    };
    window.addEventListener('popstate', popStateCb.current);

    setTimeout(() => {
      if (!history.state?.needConfirm) {
        history.pushState({ needConfirm: true }, null);
      }
    });

    return () => {
      window.removeEventListener('popstate', popStateCb.current);
    };
  }, []);
  return () => {
    window.removeEventListener('popstate', popStateCb.current);
    history.back();
  };
}
